@if (showNav) {
  <div>
    <mat-nav-list
      class="mb-4"
      [class.topPadding]="onMobileScreen"
      (click)="onSideNavClose()">
      <!--Normal user navigation-->
      @if (normalNav && (router.url !== '/landing-page')) {
        @for (t of navTabsNormalUser; track t) {
          <a
            routerLink={{t.path}}
            [hidden]="!t.userCondition && !t.deviceCondition">
            @if (
              (t.userCondition === true ? true : false) &&
              t.deviceCondition === true ? true : false) {
              <mat-list-item
                routerLinkActive="active"
                [matTooltipDisabled]="showTitles"
                matTooltip="{{ t.name | translate }}"
                matTooltipPosition="after"
                matTooltipClass="navTooltipStyle"
                matTooltipShowDelay="50"
                matTooltipHideDelay="150"
                class="text-light"
                [routerLinkActiveOptions]="{ exact: true }">
                <div [ngClass]="{'centerItem' : !showTitles}">
                  <i class={{t.fa_icon}} aria-hidden="true"></i>
                  @if (showTitles) {
                    <span>
                      {{ t.name | translate }}
                    </span>
                  }
                </div>
              </mat-list-item>
            }
          </a>
        }
      }
      <!--Customer admin user navigation-->
      @if (custAdminNav && (router.url !== '/landing-page')) {
        @for (t of navTabsCustomerAdmin; track t) {
          <a
            routerLink={{t.path}}
            [hidden]="!t.userCondition && !t.deviceCondition">
            @if (
              (t.userCondition === true ? true : false) &&
              t.deviceCondition === true ? true : false) {
              <mat-list-item
                routerLinkActive="active"
                [matTooltipDisabled]="showTitles"
                matTooltip="{{ t.name | translate }}"
                matTooltipPosition="after"
                matTooltipClass="navTooltipStyle"
                matTooltipShowDelay="50"
                matTooltipHideDelay="150"
                class="text-light"
                [routerLinkActiveOptions]="{ exact: true }">
                <div [ngClass]="{'centerItem' : !showTitles}">
                  <i class={{t.fa_icon}} aria-hidden="true"></i>
                  @if (showTitles) {
                    <span>
                      {{ t.name | translate }}
                    </span>
                  }
                </div>
              </mat-list-item>
            }
          </a>
        }
      }
      <!-- Admin user navigation -->
      @if (adminNav && !router.url.startsWith('/landing-page/')) {
        <ng-container
          (click)="onSideNavClose()">
          @for (t of navTabsAdmin; track t) {
            @if (['Internal portal', 'Keysync', 'OnOn-Core'].includes(t.name) && router.url === '/dashboard/admin') {
              <a [href]="t.path" target="_blank" rel="noopener noreferrer">
                <mat-list-item
                  class="text-light"
                  [matTooltipDisabled]="showTitles"
                  matTooltip="{{ t.name | translate }}"
                  matTooltipPosition="after"
                  matTooltipClass="navTooltipStyle"
                  matTooltipShowDelay="50"
                  matTooltipHideDelay="150">
                  <div class="nav-item-content" [ngClass]="{'centerItem' : !showTitles}">
                    <div class="text-and-icon">
                      <i class="{{ t.fa_icon }}" aria-hidden="true"></i>
                      @if (showTitles) {
                        <span>{{ t.name | translate }}</span>
                      }
                    </div>
                    @if (showTitles) {
                      <i
                        class="fa-solid fa-arrow-up-right-from-square external-link-icon"
                      aria-hidden="true"></i>
                    }
                  </div>
                </mat-list-item>
              </a>
            }
            @if (!['Internal portal', 'Keysync', 'OnOn-Core'].includes(t.name)) {
              <a [routerLink]="t.path">
                <mat-list-item
                  routerLinkActive="active"
                  class="text-light"
                  matTooltip="{{ t.name | translate }}"
                  matTooltipPosition="after"
                  [matTooltipDisabled]="showTitles"
                  matTooltipClass="navTooltipStyle"
                  matTooltipShowDelay="50"
                  matTooltipHideDelay="150"
                  [routerLinkActiveOptions]="{ exact: true }">
                  <div [ngClass]="{'centerItem' : !showTitles}">
                    <i class="{{ t.fa_icon }}" aria-hidden="true"></i>
                    @if (showTitles) {
                      <span >{{ t.name | translate }}</span>
                    }
                  </div>
                </mat-list-item>
              </a>
            }
          }
        </ng-container>
      }
      <!-- Clocks for control room-->
      @if (showCrClocks && (router.url !== '/landing-page')) {
        <div
          class="crClocks">
          <div mat-list-item class="mx-2 mt-4">
            <control-room-clock
              [timeZone]="'Europe/Helsinki'"
            [img]="'fi'"></control-room-clock>
          </div>
          <div mat-list-item class="mt-4">
            <control-room-clock
              [timeZone]="'Europe/Stockholm'"
            [img]="'sv'"></control-room-clock>
          </div>
          <div mat-list-item class="mx-2 mt-4">
            <control-room-clock
              [timeZone]="'Europe/London'"
            [img]="'uk'"></control-room-clock>
          </div>
        </div>
      }
      <!-- Landing page navigation -->
      @if (router.url.includes('/landing-page') && (landingPageUser?.user?.roleLevel === 95 || landingPageUser?.user?.roleLevel === 130)) {
        @for (t of navTabsLandingPage; track t) {
          <a
            routerLink={{t.path}}>
            <mat-list-item
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              matTooltip="{{ t.name | translate }}"
              matTooltipPosition="after"
              [matTooltipDisabled]="showTitles"
              matTooltipClass="navTooltipStyle"
              matTooltipShowDelay="50"
              matTooltipHideDelay="150"
              class="text-light">
              <i class={{t.fa_icon}} aria-hidden="true"></i>
              @if (showTitles) {
                <span>
                  {{ t.name | translate }}
                </span>
              }
            </mat-list-item>
          </a>
        }
      }
    </mat-nav-list>
  </div>
}
